import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Space, Tag, theme, Tooltip } from "antd";
import { useState } from "react";

const MAX_VISIBLE_TAG_LENGTH = 20;

const MultipleTagInput = ({ value = [], suggestions = [], onChange }) => {
  const { token } = theme.useToken();
  const [inputValue, setInputValue] = useState("");
  const [inputVisible, setInputVisible] = useState(false);

  const addInput = (candidate) => {
    if (candidate && !value.includes(candidate)) {
      onChange([...value, candidate]);
    }
  };

  const handleClose = (removedInput) => onChange(value.filter((input) => input !== removedInput));

  const handleInputConfirm = () => {
    addInput(inputValue.trim());
    setInputVisible(false);
    setInputValue("");
  };

  const availableSuggestions = suggestions.filter((item) => !value.includes(item));

  return (
    <div>
      <Space size={[4, 8]} wrap>
        {(value || []).map((input) => {
          const isLongTag = input?.length > MAX_VISIBLE_TAG_LENGTH;
          const label = isLongTag ? `${input.slice(0, MAX_VISIBLE_TAG_LENGTH)}…` : input;
          const tagElem = (
            <Tag
              key={input}
              closable
              onClose={() => handleClose(input)}
              style={{ marginInlineEnd: 0 }}
            >
              {label}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={input} key={input}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}

        {inputVisible ? (
          <Input
            type="text"
            size="small"
            style={{ width: "min(200px, 100%)" }}
            value={inputValue}
            placeholder="Type, then press Enter"
            onChange={(event) => setInputValue(event.target.value)}
            onBlur={handleInputConfirm}
            onPressEnter={handleInputConfirm}
          />
        ) : (
          // Theme-token styled so the dashed "add" chip reads correctly in both light and dark themes.
          <Tag
            onClick={() => setInputVisible(true)}
            style={{
              background: token.colorFillQuaternary,
              borderStyle: "dashed",
              borderColor: token.colorBorder,
              color: token.colorTextSecondary,
              cursor: "pointer",
              marginInlineEnd: 0
            }}
          >
            <PlusOutlined /> Add new
          </Tag>
        )}
      </Space>

      {availableSuggestions.length > 0 && (
        <>
          <Divider style={{ margin: "8px 0" }} />
          <Space size={[4, 4]} wrap>
            {availableSuggestions.map((item) => (
              <Tag
                key={item}
                color="blue"
                onClick={() => addInput(item)}
                style={{ cursor: "pointer", marginInlineEnd: 0 }}
              >
                {item}
              </Tag>
            ))}
          </Space>
        </>
      )}
    </div>
  );
};

export default MultipleTagInput;
